import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { common_axios } from "../../../../App";
import { toast, ToastContainer } from "react-toastify";
import CheckBox from "../../Reacttable/UserManagement/ReactTableFiles/CheckBox";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import TableViewIcon from "@mui/icons-material/TableView";
import {
  Backdrop,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextareaAutosize,
} from "@mui/material";
import Loader from "../../../../components/Loader";
import { SettingsInputComponent } from "@mui/icons-material";
import { dateFormatter } from "../../../../helper/helper";
import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import MappedAudio from "./MappedAudio";

import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setsavebutton } from "../../../../redux/features/CampaignSlice";
export default function AdminVoiceUploadsApproval() {
  const cancleeeee = useRef();

  const getsavedisable = useSelector((data) => data?.CampaignSlice?.savebutton);
  const dispatch = useDispatch();

  console.log("redixvaluii", getsavedisable);

  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [selectedUserDetailAssign, setSelectedUserDetailAssign] =
    useState(undefined);
  const [selecteddeleteid, setselecteddeleteid] = useState(undefined);
  const [showbrows, setshowbrows] = useState(false);
  const [emptyfiles, setemptyfiles] = useState("");
  const [emptyfilesshwo, setemptyfilesshwo] = useState(false);
  const [Status, setStatus] = useState({
    approveType: 0,
    resellerName: null,
    type: null,
    approveAssignedType: null,
    hideShow: false,
  });
  //   const [onVoiceChange, setonVoiceChange] = useState(false);
  const [counts, setcounts] = useState();
  const [Pendingcount, setPendingcount] = useState();
  const [Rejectcount, setRejectcount] = useState();
  const [Approvedcount, setApprovedcount] = useState();
  const customId1 = "custom-id-yes";

  // const [bttndisable, setbttndisable] = useState("");

  const [totalPage, setTotalPage] = useState();
  const [totalPageCount, settotalPageCount] = useState(0);
  const [totalPageCountShow, settotalPageCountShow] = useState(1);
  // const [totalPageCount, settotalPageCount] = useState(0);
  const [pageNumber1, setPageNumber1] = useState(0);
  const [disabledPrevious, setDisabledPrevious] = useState(true);
  const [disableNext, setDisableNext] = useState(true);
  // const [PageSize, setPageSize] = useState(10);

  // const callbackvalluuee = (value) => {
  //   console.log("datad4555444d4444d", value);
  // };

  const fetchUserr = async () => {
    try {
      setOpen(true);
      if (Status.approveType == 3) {
      } else if (
        Status.approveType == 1 &&
        Status.approveAssignedType != null
      ) {
      } else {
        const res = await common_axios.get(
          //   `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/admin/v1/voice-campaign/approve?approveStatus=${Status?.approveType}`
          `${
            process.env.REACT_APP_COMMON_API_CAMPAIGN
          }/voice/v1/voice-campaign/get-obd?approveStatus=${
            Status?.approveType
          }&pageNo=${Number(
            totalPageCount == -1 ? 0 : totalPageCount
          )}&pageSize=${pageSize}`
        );
        console.log("hskhhu", res.data);

        if (res.data.statusDescription.statusCode == 200) {
          await setData(res?.data?.obdPrompts?.content);
          await setTotalPage(res?.data?.obdPrompts?.totalPages);
          await settotalPageCount(res?.data?.obdPrompts?.number);
          setOpen(false);
        } else if (res.data.statusDescription.statusCode == 220) {
          setData([]);
          setOpen(false);
          await toast.error(res.data.statusDescription.statusMessage, {
            theme: "colored",
          });
        } else {
          setOpen(false);
          await toast.error(res.data.statusDescription.statusMessage, {
            theme: "colored",
            toastId: customId1,
          });
        }
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };
  console.log("res77889899", selectedUserDetail?.approvedNew);
  useEffect(async () => {
    if (totalPageCount <= 0 || totalPageCount != -1) {
      fetchUserr();
      await getcountcampaign();
    }
    // fetchUserr();
  }, [Status?.approveType, totalPageCount]);

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);
  const modelButtonAssign = useRef(null);

  const Editfromreject = async (cell) => {
    cell.row.original.approvedNew = await cell.row.original.approved;
    console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };
  const Deletefromreject = async (cell) => {
    cell.row.original["resellerName"] = "";
    await setSelectedUserDetailAssign(cell.row.original);
    // await setselecteddeleteid(cell.row.original);
    await modelButtonAssign.current.click();
  };

  const rejectUserModal = async (cell) => {
    cell.row.original.approvedNew = await cell.row.original.approved;
    console.log("hhbdhdhhddddddddddddd", cell.row.original);

    await setSelectedUserDetail(cell.row.original);
    // selectedUserDetail.approvedNew = 1;
    await modelButtonReject.current.click();
  };

  const rejectUserApi = async (e) => {
    e.preventDefault();
    const buttonn = document.getElementById("close_edit");
    try {
      buttonn.click();
      setOpen(true);
      if (Status.approveType == 3) {
      } else {
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/voice/v1/voice-campaign/approve-reject`,

          {
            id: selectedUserDetail?.id,
            rejectReason: selectedUserDetail?.rejectedReasonText,
            approveStatus:
              selectedUserDetail?.approvedNew == null
                ? 0
                : parseInt(selectedUserDetail?.approvedNew),
          }
        );
        console.log("res77889899", Status?.approveType);

        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);

          if (selectedUserDetail?.approvedNew == 1) {
            await toast.success("Voice File Approved", {
              theme: "colored",
            });
          } else if (selectedUserDetail?.approvedNew == 2) {
            await toast.error("Voice File Rejected", {
              theme: "colored",
            });
          }

          await fetchUserr();
          await getcountcampaign();
          //   fetchUser();
        } else {
          setOpen(false);
          await toast.error(res.data.statusDescription.statusMessage, {
            theme: "colored",
          });
        }
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };

  const approveUserApi = async (e) => {
    e.preventDefault();
    cancleeeee.current.click();
    setshowchoose(false);
    // setemptyfilesshwo(true);
    // const buttonn = document.getElementById("close_edit");
    try {
      //   buttonn?.click();
      setOpen(true);
      if (Status.approveType == 3) {
      } else {
        let urlmap = `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/voice/v1/voice-campaign/reupload/file?`;

        for (let i = 0; i < audioIDArray.length; i++) {
          if (i == 0) {
            urlmap = urlmap.concat(`obdFileId=${audioIDArray[i]}`);
          } else {
            urlmap = urlmap.concat(`&obdFileId=${audioIDArray[i]}`);
          }
        }
        const formData = new FormData();
        for (var i = 0; i < audioArray.length; i++) {
          console.log("audioArray", audioArray, audioArray[i]);
          formData.append("reuploadFile", audioArray[i]);
        }

        const res = await common_axios.post(
          urlmap,
          formData
          // selectedUserDetailApprove
        );

        console.log("hdhrhurhrrrrr", res);

        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);

          setaudioIDArray([]);
          setaudioArray([]);
          dispatch(setsavebutton(true));

          await toast.success("Voice File Updated", {
            theme: "colored",
          });

          await fetchUserr();
          await getcountcampaign();
          //   fetchUser();
        } else {
          setOpen(false);
          await toast.error(res.data.statusDescription.statusMessage, {
            theme: "colored",
          });
        }
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };

  // const childCllbacl = (childdata) => {
  //   console.log({ childdata });
  //   setbttndisable(childdata);
  // };

  const Deleteuserr = async (e) => {
    const buttonn = document.getElementById("close_edit2");
    e.preventDefault();
    try {
      buttonn.click();
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/voice/v1/voice-campaign/approve-reject`,
        {
          id: selectedUserDetailAssign?.id,
          // rejectReason: selectedUserDetail?.rejectedReasonText,
          approveStatus: -1,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        await toast.success("Voice File Deleted ", {
          theme: "colored",
        });
        await fetchUserr();
        await getcountcampaign();
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };

  const getcountcampaign = async (e) => {
    // const buttonn = document.getElementById("close_edit2");
    // e.preventDefault();
    try {
      //   buttonn.click();
      setOpen(true);
      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/voice/v1/voice-campaign/get/count`
      );
      console.log("resuushfisciunttt", res);

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);

        res?.data?.obdPromptCounts?.map((e) => {
          // return e?.status == 1
          //   ? setApprovedcount(e?.count)
          //   : e?.status == 2
          //   ? setRejectcount(e?.count)
          //   : setPendingcount(e?.count);
          return e?.status == 0
            ? setPendingcount(e?.count)
            : e?.status == 1
            ? setApprovedcount(e?.count)
            : e?.status == 2
            ? setRejectcount(e?.count)
            : setPendingcount(0) || setApprovedcount(0) || setRejectcount(0);
        });

        // await toast.success("Prompt Deleted Successfully", {
        //   theme: "colored",
        // });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };

  const columns = useMemo(
    () =>
      Status?.approveType == 2
        ? [
            {
              Header: "Id",
              Footer: "ID",
              accessor: "id",
            },
            {
              Header: "Created By",
              Footer: "Created By",
              accessor: "createdBy",
            },

            {
              Header: "Prompt Name",
              Footer: "Prompt Name",
              accessor: "promptName",
            },

            {
              Header: "Created Date",

              accessor: "createdOn",
              Cell: (cell) => {
                return <>{dateFormatter(cell.row.original.createdOn)}</>;
              },
            },

            {
              Header: "Approval Status",

              accessor: "approval",
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.approval == 0 ? (
                      <div className="badge badge_8 bg-warning">Pending</div>
                    ) : cell.row.original.approval == 1 ? (
                      <div className="badge badge_8 bg-success">Approved</div>
                    ) : (
                      <div className="badge badge_8 bg-danger">Rejected</div>
                    )}
                  </>
                );
              },
            },

            {
              Header: "Rejected Reason",
              Footer: "Rejected Reason",
              accessor: "rejectedReason",
            },

            {
              Header: "Action",
              Footer: "Action",
              accessor: "action",
              Cell: (cell) => (
                <>
                  {console.log("cccccceeeelllll", cell.row.original.approved)}
                  <div className="dropdown">
                    <button
                      className="btn color_1 dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="material-icons opacity-10 size">person</i>
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      {/* {cell.row.original.approved != 1 && ( */}
                      <li onClick={() => {}}>
                        <>
                          {cell.row.original.approval == 0 ? (
                            <a
                              className="dropdown-item"
                              onClick={() => {
                                rejectUserModal(cell);
                              }}
                            >
                              Edit
                            </a>
                          ) : cell.row.original.approval == 1 ? (
                            <a
                              className="dropdown-item"
                              onClick={() => {
                                rejectUserModal(cell);
                              }}
                            >
                              Edit
                            </a>
                          ) : (
                            <>
                              <a
                                className="dropdown-item"
                                onClick={() => {
                                  Editfromreject(cell);
                                }}
                              >
                                Edit
                              </a>
                              <a
                                className="dropdown-item"
                                onClick={() => {
                                  Deletefromreject(cell);
                                }}
                              >
                                Delete
                              </a>
                            </>
                          )}
                        </>
                      </li>
                      {/* // )} */}
                      <li>
                        <>
                          {/* {cell.row.original.approved == 0 ? (
                      <>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            approveUserModal(cell);
                          }}
                        >
                          Reject
                        </a>
                      </>
                    ) : cell.row.original.approved == 1 ? (
                      <>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            approveUserModal(cell);
                          }}
                        >
                          Delete
                        </a>
                      </>
                    ) : (
                      <>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            approveUserModal(cell);
                          }}
                        >
                          Delete
                        </a>
                      </>
                    )} */}
                          {/* <a
                      className="dropdown-item"
                      onClick={() => {
                        approveUserModal(cell);
                      }}
                    >
                      Reject
                    </a> */}
                        </>
                      </li>
                    </ul>
                  </div>
                </>
              ),

              disableFilters: true,
            },
          ]
        : Status?.approveType == 1
        ? [
            {
              Header: "Id",
              Footer: "ID",
              accessor: "id",
            },

            {
              Header: "Created By",
              Footer: "Created By",
              accessor: "createdBy",
            },
            {
              Header: "Prompt Name",
              Footer: "Prompt Name",
              accessor: "promptName",
            },

            {
              Header: "Created Date",

              accessor: "createdDate",
              Cell: (cell) => {
                return <>{dateFormatter(cell.row.original.createdDate)}</>;
              },
            },

            {
              Header: "Approval Status",

              accessor: "approval",
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.approval == 0 ? (
                      <div className="badge badge_8 bg-warning">Pending</div>
                    ) : cell.row.original.approval == 1 ? (
                      <div className="badge badge_8 bg-success">Approved</div>
                    ) : (
                      <div className="badge badge_8 bg-danger">Rejected</div>
                    )}
                  </>
                );
              },
            },
            {
              Header: "Approval Date",

              accessor: "verifiedDate",
              Cell: (cell) => {
                return <>{dateFormatter(cell.row.original.verifiedDate)}</>;
              },
            },

            {
              Header: "Action",
              Footer: "Action",
              accessor: "action",
              Cell: (cell) => (
                <>
                  {console.log("cccccceeeelllll", cell.row.original.approved)}
                  <div className="dropdown">
                    <button
                      className="btn color_1 dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="material-icons opacity-10 size">person</i>
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      {/* {cell.row.original.approved != 1 && ( */}
                      <li onClick={() => {}}>
                        <>
                          {cell.row.original.approval == 0 ? (
                            <a
                              className="dropdown-item"
                              onClick={() => {
                                rejectUserModal(cell);
                              }}
                            >
                              Edit
                            </a>
                          ) : cell.row.original.approval == 1 ? (
                            <a
                              className="dropdown-item"
                              onClick={() => {
                                rejectUserModal(cell);
                              }}
                            >
                              Edit
                            </a>
                          ) : (
                            <>
                              <a
                                className="dropdown-item"
                                onClick={() => {
                                  Editfromreject(cell);
                                }}
                              >
                                Edit
                              </a>
                              <a
                                className="dropdown-item"
                                onClick={() => {
                                  Deletefromreject(cell);
                                }}
                              >
                                Delete
                              </a>
                            </>
                          )}
                        </>
                      </li>
                      {/* // )} */}
                      <li>
                        <>
                          {/* {cell.row.original.approved == 0 ? (
                      <>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            approveUserModal(cell);
                          }}
                        >
                          Reject
                        </a>
                      </>
                    ) : cell.row.original.approved == 1 ? (
                      <>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            approveUserModal(cell);
                          }}
                        >
                          Delete
                        </a>
                      </>
                    ) : (
                      <>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            approveUserModal(cell);
                          }}
                        >
                          Delete
                        </a>
                      </>
                    )} */}
                          {/* <a
                      className="dropdown-item"
                      onClick={() => {
                        approveUserModal(cell);
                      }}
                    >
                      Reject
                    </a> */}
                        </>
                      </li>
                    </ul>
                  </div>
                </>
              ),

              disableFilters: true,
            },
          ]
        : [
            {
              Header: "Id",
              Footer: "ID",
              accessor: "id",
            },
            {
              Header: "Created By",
              Footer: "Created By",
              accessor: "createdBy",
            },
            {
              Header: "Prompt Name",
              Footer: "Prompt Name",
              accessor: "promptName",
            },

            {
              Header: "Created Date",

              accessor: "createdDate",
              Cell: (cell) => {
                return <>{dateFormatter(cell.row.original.createdDate)}</>;
              },
            },

            {
              Header: "Approval Status",

              accessor: "approval",
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.approval == 0 ? (
                      <div className="badge badge_8 bg-warning">Pending</div>
                    ) : cell.row.original.approval == 1 ? (
                      <div className="badge badge_8 bg-success">Approved</div>
                    ) : (
                      <div className="badge badge_8 bg-danger">Rejected</div>
                    )}
                  </>
                );
              },
            },

            {
              Header: "Action",
              Footer: "Action",
              accessor: "action",
              Cell: (cell) => (
                <>
                  {console.log("cccccceeeelllll", cell.row.original.approved)}
                  <div className="dropdown">
                    <button
                      className="btn color_1 dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="material-icons opacity-10 size">person</i>
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      {/* {cell.row.original.approved != 1 && ( */}
                      <li onClick={() => {}}>
                        <>
                          {cell.row.original.approval == 0 ? (
                            <a
                              className="dropdown-item"
                              onClick={() => {
                                rejectUserModal(cell);
                              }}
                            >
                              Edit
                            </a>
                          ) : cell.row.original.approval == 1 ? (
                            <a
                              className="dropdown-item"
                              onClick={() => {
                                rejectUserModal(cell);
                              }}
                            >
                              Edit
                            </a>
                          ) : (
                            <>
                              <a
                                className="dropdown-item"
                                onClick={() => {
                                  Editfromreject(cell);
                                }}
                              >
                                Edit
                              </a>
                              <a
                                className="dropdown-item"
                                onClick={() => {
                                  Deletefromreject(cell);
                                }}
                              >
                                Delete
                              </a>
                            </>
                          )}
                        </>
                      </li>
                      {/* // )} */}
                      <li>
                        <>
                          {/* {cell.row.original.approved == 0 ? (
                      <>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            approveUserModal(cell);
                          }}
                        >
                          Reject
                        </a>
                      </>
                    ) : cell.row.original.approved == 1 ? (
                      <>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            approveUserModal(cell);
                          }}
                        >
                          Delete
                        </a>
                      </>
                    ) : (
                      <>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            approveUserModal(cell);
                          }}
                        >
                          Delete
                        </a>
                      </>
                    )} */}
                          {/* <a
                      className="dropdown-item"
                      onClick={() => {
                        approveUserModal(cell);
                      }}
                    >
                      Reject
                    </a> */}
                        </>
                      </li>
                    </ul>
                  </div>
                </>
              ),

              disableFilters: true,
            },
          ],
    [Status?.approveType]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );
  console.log("valuueuee", selectedUserDetail?.approved);

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);
  const onChangeTe = useAsyncDebounce((e) => {
    settotalPageCountShow(e || 1);
    settotalPageCount(e - 1 || 0);
    console.log(e, "hello ji");
  }, 10);

  const deletUser = () => {
    console.log({ selectedFlatRows });
  };

  const [audioArray, setaudioArray] = useState([]);
  const [audioIDArray, setaudioIDArray] = useState([]);
  const [trufalse, settrufalse] = useState(true);

  console.log("datadd4444d", trufalse);

  console.log("valuueuee", audioArray);

  console.log("dddhhdhdhhhd", audioArray, audioIDArray);
  const [showchoose, setshowchoose] = useState(false);

  useEffect(() => {
    getcountcampaign();
  }, [Status]);

  console.log(selectedUserDetail);

  const NextPage = () => {
    settotalPageCount(totalPageCount + 1);
    settotalPageCountShow(totalPageCount + 2);
  };

  const PreviousPage = () => {
    settotalPageCount(totalPageCount - 1);
    settotalPageCountShow(totalPageCount);
  };

  useEffect(() => {
    if (totalPageCount > totalPage) {
      settotalPageCount(0);
      setPageNumber1(0);
    }
  }, [totalPageCount]);

  useEffect(async () => {
    fetchUserr();
  }, [Status?.approveType, pageSize, totalPageCount]);

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      {selectedUserDetail != undefined && (
        <div>
          {console.log("dddhhdhdhhh45656d", selectedUserDetail)}
          <button
            ref={modelButtonReject}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Status Update
                  </h5>
                  <button
                    onClick={() => {
                      setSelectedUserDetail(null);
                    }}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <form onSubmit={rejectUserApi}>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          <span className="d-block font-weight-bold">
                            {" "}
                            Prompt Name:
                          </span>
                          {selectedUserDetail?.promptName}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mt-2">
                        <label for="exampleInputEmail1" className="form-label">
                          OBD Type:
                        </label>
                        <input
                          required
                          disabled
                          className="form-control"
                          placeholder="Telemarketer Id Here"
                          type="text"
                          minLength="3"
                          // value={selectedUserDetail?.eventName}
                          value={selectedUserDetail?.obd}
                          // onChange={(e) => {
                          //   setSelectedUserDetail({
                          //     ...selectedUserDetail,
                          //     telemarketerId: e.target.value,
                          //   });
                          // }}
                        />
                      </div>

                      <div className="col-md-6 mt-2">
                        <label for="exampleInputEmail1" className="form-label">
                          Approval Status
                        </label>
                        <select
                          className="form-select"
                          value={selectedUserDetail?.approvedNew}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              approvedNew: e.target.value,
                            });
                          }}
                        >
                          {selectedUserDetail.approval == 1
                            ? [
                                {
                                  id: 0,
                                  name: "Please select",
                                  value: selectedUserDetail?.approval,
                                },

                                {
                                  id: 1,
                                  name: "Reject",
                                  value: 2,
                                },
                              ].map((d) => {
                                return (
                                  <option value={d.value} key={d.name}>
                                    {d.name}
                                  </option>
                                );
                              })
                            : selectedUserDetail.approval == 0
                            ? [
                                {
                                  id: 0,
                                  name: "Please select",
                                  value: selectedUserDetail?.approval,
                                },
                                {
                                  id: 1,
                                  name: "Approve",
                                  value: 1,
                                },
                                {
                                  id: 2,
                                  name: "Reject",
                                  value: 2,
                                },
                              ].map((d) => {
                                return (
                                  <option value={d.value} key={d.name}>
                                    {d.name}
                                  </option>
                                );
                              })
                            : [
                                {
                                  id: 0,
                                  name: "Please select",
                                  value: selectedUserDetail?.approval,
                                },
                                {
                                  id: 1,
                                  name: "Pending",
                                  value: 0,
                                },
                              ].map((d) => {
                                return (
                                  <option value={d.value} key={d.name}>
                                    {d.name}
                                  </option>
                                );
                              })}
                        </select>
                      </div>
                      <div className="row">
                        {selectedUserDetail.approvedNew == "2" && (
                          <div className="col-md-6 mt-4">
                            <label>Rejected Reason:</label>
                            <input
                              required
                              className="form-control mt-2"
                              placeholder="Reason of Rejection"
                              type="text"
                              value={selectedUserDetail.rejectedReasonText}
                              onChange={(e) => {
                                setSelectedUserDetail({
                                  ...selectedUserDetail,
                                  rejectedReasonText: e.target.value,
                                });
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    {Status?.approveType == 0 ? (
                      <>
                        <div className="my-2">
                          <span className="d-block font-weight-bold">
                            Preview Audio
                          </span>
                          <div className="d-block align-items-center">
                            <span className="d-block"></span>
                            {selectedUserDetail?.obdFileUpload?.length == 0 ? (
                              <>No voice files available</>
                            ) : (
                              <>
                                {selectedUserDetail?.obdFileUpload?.map(
                                  (data) => {
                                    return (
                                      <>
                                        <div className="row w-100">
                                          <div className="col-md-12">
                                            <label>
                                              File Name{data.filename}
                                            </label>
                                          </div>
                                        </div>
                                        <audio
                                          className="m-0 w-100"
                                          controls
                                          src={data?.downlaodUrl}
                                        >
                                          <a href={data?.downlaodUrl}>
                                            Download audio
                                          </a>
                                        </audio>
                                      </>
                                    );
                                  }
                                )}
                              </>
                            )}

                            {/* src="http://192.168.167.66:5050/voiceClip/test4.wav" */}
                          </div>
                        </div>
                      </>
                    ) : Status?.approveType == 1 ? (
                      <>
                        <div className="my-2">
                          <span className="d-block font-weight-bold">
                            Preview Audio
                          </span>
                          <div className="d-block align-items-center">
                            <span className="d-block"></span>
                            {selectedUserDetail?.obdFileUpload?.length == 0 ? (
                              <>No voice files available</>
                            ) : (
                              <>
                                {selectedUserDetail?.obdFileUpload?.map(
                                  (data) => {
                                    return (
                                      <>
                                        <div className="row w-100">
                                          <div className="col-md-12">
                                            <label>
                                              File Name{data.filename}
                                            </label>
                                          </div>
                                        </div>
                                        <audio
                                          className="m-0 w-100"
                                          controls
                                          src={data?.downlaodUrl}
                                        >
                                          <a href={data?.downlaodUrl}>
                                            Download audio
                                          </a>
                                        </audio>
                                      </>
                                    );
                                  }
                                )}
                              </>
                            )}

                            {/* src="http://192.168.167.66:5050/voiceClip/test4.wav" */}
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {/* <div className="row mt-2">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Created By:
                        </label>

                        <input
                          type="text"
                          disabled
                          value={selectedUserDetail?.createdBy}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>

                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Template Name
                        </label>
                        <input
                          required
                          className="form-control"
                          placeholder="Telemarketer Id Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetail?.templateName}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              templateName: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div> */}

                    {/* 
                    <div className="row mt-2">
                      <div className="col-md-12">
                        <label className="text-start">Template</label>
                        <TextareaAutosize
                          className="w-100"
                          value={selectedUserDetail?.templateDescription}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              templateDescription: e.target.value,
                            });
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .toString()
                              .slice(0, 1000);
                          }}
                          required
                          name="templateDesc"
                          fullWidth
                          aria-label="minimum height"
                          minRows={5}
                          //   style={{ minHeight: "150px" }}

                          placeholder="Enter Template"
                        />
                      </div>
                    </div> */}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedUserDetail(null);
                      }}
                      id="close_edit"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Update
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedUserDetailApprove != undefined && (
        <>
          {console.log("v4664765alueuueue", selectedUserDetailApprove)}
          <div>
            <button
              ref={modelButtonApprove}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop1"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop1"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdrop1Label"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdrop1Label">
                      {/* Are you sure you want to Edit */}
                      Voice File Preview
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        setaudioIDArray([]);
                        setaudioArray([]);
                        dispatch(setsavebutton(true));
                        // settrufalse(true);
                        setSelectedUserDetailApprove(null);
                      }}
                    ></button>
                  </div>
                  <div className="modal-body">
                    {/* <div className="row"> */}
                    {/* <div className="col-md-6"> */}
                    <label for="exampleInputEmail1" className="form-label m-0">
                      <span className="d-block font-weight-bold my-2">
                        Prompt Name:{" "}
                      </span>
                      {selectedUserDetailApprove?.promptName}
                    </label>

                    <div className="row">
                      <div className="col-md-6 mt-2">
                        <label for="exampleInputEmail1" className="form-label">
                          OBD Type:
                        </label>
                        <input
                          required
                          disabled
                          className="form-control"
                          placeholder="Telemarketer Id Here"
                          type="text"
                          minLength="3"
                          // value={selectedUserDetail?.eventName}
                          value={selectedUserDetailApprove?.obd}
                          // onChange={(e) => {
                          //   setSelectedUserDetail({
                          //     ...selectedUserDetail,
                          //     telemarketerId: e.target.value,
                          //   });
                          // }}
                        />
                      </div>
                      <div className="col-md-6 mt-2">
                        <label for="exampleInputEmail1" className="form-label">
                          Rejected Reason:
                        </label>
                        <input
                          required
                          disabled
                          className="form-control"
                          placeholder=" Rejected Reason Here"
                          type="text"
                          minLength="3"
                          // value={selectedUserDetail?.eventName}
                          value={selectedUserDetailApprove?.rejectedReason}
                          // onChange={(e) => {
                          //   setSelectedUserDetail({
                          //     ...selectedUserDetail,
                          //     telemarketerId: e.target.value,
                          //   });
                          // }}
                        />
                      </div>
                    </div>
                    {/* <div className="row">
                      <label
                        for="exampleInputEmail1"
                        className="form-label  m-0 mt-3"
                      >
                        <span className="font-weight-bold">
                          {" "}
                          Rejected Reason:{" "}
                        </span>
                      

                        {selectedUserDetailApprove?.rejectedReason}
                   
                      </label>
                    </div> */}
                    {/* </div> */}
                    {/* <div className="row"> */}
                    <span className="d-block font-weight-bold my-2">
                      Preview Audio or Edit
                    </span>
                    <form onSubmit={approveUserApi}>
                      <div
                        className="d-block align-items-center"
                        style={{ padding: "0px 15px" }}
                      >
                        {selectedUserDetailApprove.obdFileUpload.length == 0 ? (
                          <>No voice files available</>
                        ) : (
                          <>
                            {selectedUserDetailApprove.obdFileUpload &&
                              selectedUserDetailApprove.obdFileUpload?.map(
                                (data, index) => {
                                  return (
                                    <>
                                      <MappedAudio
                                        // parentCallback={childCllbacl}
                                        data={data}
                                        audioArray={audioArray}
                                        setaudioIDArray
                                        audioIDArray={audioIDArray}
                                        setaudioArray
                                        trufalse={trufalse}
                                        settrufalse
                                        // parentCallback={callbackvalluuee}
                                      />
                                    </>
                                  );
                                }
                              )}
                          </>
                        )}

                        {/* {showchoose == true && ( */}
                        <>
                          {" "}
                          {/* {emptyfiles == 1 ? (
                            <>
                              {" "}
                              <div className="col-md-6">
                                <div
                                  class="  input-group m-0 mb-3"
                                  id="input_group_8"
                                >
                                  <Button
                                    //   disabled={Radiosdisabled.choose}
                                    variant="contained"
                                    component="label"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <input
                                      // accept="application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet"
                                      multiple
                                      // required={RadioGroupValues == 4}
                                      required
                                      // value={getAudioF1.fileuplode}
                                      id="fileName"
                                      type="file"
                                      style={{
                                        color: "#7b809a",
                                      }}
                                      // onChange={(e) => {
                                      //   setgetAudioF1({
                                      //     ...getAudioF1,
                                      //     fileuplode: e.target.files[0],
                                      //   });
                                      // }}
                                      onChange={(e, filee) => {
                                        handlechangeAudioF1(e, filee);
                                      }}
                                    />
                                  </Button>
                                </div>
                              </div>
                            </>
                          ) : emptyfiles == 2 ? (
                            <>
                              <div className="col-md-6">
                                <div
                                  class="  input-group m-0 mb-3"
                                  id="input_group_8"
                                >
                                  <Button
                                    //   disabled={Radiosdisabled.choose}
                                    variant="contained"
                                    component="label"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <input
                                      // accept="application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet"
                                      multiple
                                      // required={RadioGroupValues == 4}
                                      required
                                      // value={getAudioF1.fileuplode}
                                      id="fileName2"
                                      type="file"
                                      style={{
                                        color: "#7b809a",
                                      }}
                                      // onChange={(e) => {
                                      //   setgetAudioF1({
                                      //     ...getAudioF1,
                                      //     fileuplode: e.target.files[0],
                                      //   });
                                      // }}
                                      onChange={(e, filee) => {
                                        handleChangePrompt_pair(e, filee);
                                      }}
                                    />
                                  </Button>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div
                                  class="  input-group m-0 mb-3"
                                  id="input_group_8"
                                >
                                  <Button
                                    //   disabled={Radiosdisabled.choose}
                                    variant="contained"
                                    component="label"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <input
                                      // accept="application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet"
                                      multiple
                                      // required={RadioGroupValues == 4}
                                      required
                                      // value={getAudioF1.fileuplode}
                                      id="fileName3"
                                      type="file"
                                      style={{
                                        color: "#7b809a",
                                      }}
                                      // onChange={(e) => {
                                      //   setgetAudioF1({
                                      //     ...getAudioF1,
                                      //     fileuplode: e.target.files[0],
                                      //   });
                                      // }}
                                      onChange={(e, filee) => {
                                        handleChangePrompt_pair_2(e, filee);
                                      }}
                                    />
                                  </Button>
                                </div>
                              </div>
                            </>
                          ) : emptyfiles == 3 ? (
                            <>
                              <div className="col-md-6">
                                <div
                                  class="  input-group m-0 mb-3"
                                  id="input_group_8"
                                >
                                  <Button
                                    //   disabled={Radiosdisabled.choose}
                                    variant="contained"
                                    component="label"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <input
                                      // accept="application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet"
                                      multiple
                                      // required={RadioGroupValues == 4}
                                      required
                                      // value={getAudioF1.fileuplode}
                                      id="fileName4"
                                      type="file"
                                      style={{
                                        color: "#7b809a",
                                      }}
                                      // onChange={(e) => {
                                      //   setgetAudioF1({
                                      //     ...getAudioF1,
                                      //     fileuplode: e.target.files[0],
                                      //   });
                                      // }}
                                      onChange={(e, filee) => {
                                        handleChangePrompt_pair_3(e, filee);
                                      }}
                                    />
                                  </Button>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div
                                  class="  input-group m-0 mb-3"
                                  id="input_group_8"
                                >
                                  <Button
                                    //   disabled={Radiosdisabled.choose}
                                    variant="contained"
                                    component="label"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <input
                                      // accept="application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet"
                                      multiple
                                      // required={RadioGroupValues == 4}
                                      required
                                      // value={getAudioF1.fileuplode}
                                      id="fileName5"
                                      type="file"
                                      style={{
                                        color: "#7b809a",
                                      }}
                                      // onChange={(e) => {
                                      //   setgetAudioF1({
                                      //     ...getAudioF1,
                                      //     fileuplode: e.target.files[0],
                                      //   });
                                      // }}
                                      onChange={(e, filee) => {
                                        handleChangePrompt_pair_3_1(e, filee);
                                      }}
                                    />
                                  </Button>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div
                                  class="  input-group m-0 mb-3"
                                  id="input_group_8"
                                >
                                  <Button
                                    //   disabled={Radiosdisabled.choose}
                                    variant="contained"
                                    component="label"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <input
                                      // accept="application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet"
                                      multiple
                                      // required={RadioGroupValues == 4}
                                      required
                                      // value={getAudioF1.fileuplode}
                                      id="fileName6"
                                      type="file"
                                      style={{
                                        color: "#7b809a",
                                      }}
                                      // onChange={(e) => {
                                      //   setgetAudioF1({
                                      //     ...getAudioF1,
                                      //     fileuplode: e.target.files[0],
                                      //   });
                                      // }}
                                      onChange={(e, filee) => {
                                        handleChangePrompt_pair_3_2(e, filee);
                                      }}
                                    />
                                  </Button>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )} */}
                        </>
                        {/* //   )} */}

                        {/* <audio
                        className="m-0 w-100 my-2"
                        controls
                        src="http://192.168.167.66:5050/voiceClip/test5.wav"
                      >
                        <a href="http://192.168.167.66:5050/voiceClip/test5.wav">
                          Download audio
                        </a>
                      </audio>
                      <audio
                        className="m-0 w-100"
                        controls
                        src="http://192.168.167.66:5050/voiceClip/test6.wav"
                      >
                        <a href="http://192.168.167.66:5050/voiceClip/test6.wav">
                          Download audio
                        </a>
                      </audio> */}
                        {/* <audio
                          className="mt-2 ms-2"
                          controls
                          src="http://192.168.167.66:5050/voiceClip/test7.wav"
                        >
                          <a href="http://192.168.167.66:5050/voiceClip/test7.wav">
                            Download audio
                          </a>
                        </audio> */}
                      </div>
                      {/* </div> */}
                      {/* </div> */}

                      {/* <div className="modal-body">
                  
                  <div className="mt-4">
                    <div className="row justify-content-center align-items-center mx-0 my-3">
                      <div className="col-4 px-0">
                        <h6 className="text-capitalize text-end">Sender Id:</h6>
                      </div>
                      <div className="col-4 px-0 ms-5">
                        <h6 className="text-capitalize">
                          {selectedUserDetailApprove?.senderId}
                        </h6>
                      </div>
                    </div>
                    <div className="row justify-content-center align-items-center mx-0">
                      <div className="col-4 px-0">
                        <h6 className="text-capitalize text-end">DLT PE Id:</h6>
                      </div>
                      <div className="col-4 px-0 ms-5">
                        <h6 className="text-capitalize">
                          {selectedUserDetailApprove?.dltId}
                        </h6>
                      </div>
                    </div>
                    <div className="row justify-content-center align-items-center mx-0 my-3">
                      <div className="col-4 px-0">
                        <h6 className="text-capitalize text-end">Category:</h6>
                      </div>
                      <div className="col-4 px-0 ms-5">
                        <h6 className="">
                          {selectedUserDetailApprove?.category}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div> */}
                      <div className="modal-footer">
                        <button
                          ref={cancleeeee}
                          type="button"
                          id="close_edit1"
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setaudioIDArray([]);
                            setaudioArray([]);
                            // settrufalse(true);
                            dispatch(setsavebutton(true));
                            setSelectedUserDetailApprove(null);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          // disabled={audioArray.length == 0}
                          type="submit"
                          className="btn btn-primary"
                          // data-bs-dismiss="modal"
                          //   onClick={() => {
                          //     approveUserApi();
                          //   }}
                          disabled={getsavedisable}
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {selectedUserDetailAssign != undefined && (
        <div>
          <button
            ref={modelButtonAssign}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop2"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop2"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Are you sure you want to Delete
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <form onSubmit={Deleteuserr}>
                  <div className="modal-body">
                    {/* <div className="row">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          DLT PE Id:
                        </label>
           
                        <input
                          disabled
                          className="form-control"
                          placeholder="DLT PE Id Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetailAssign?.dltId}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              dltId: e.target.value,
                            });
                          }}
                        />
                       
                      </div>
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Category
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailAssign?.category}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Sender Id
                        </label>
                        <input
                          disabled
                          required
                          className="form-control"
                          placeholder="Sender Id Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetailAssign?.senderId}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              senderId: e.target.value,
                            });
                          }}
                        />
                      </div>

                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Assign Sender Id to:
                        </label>
                        <Autocomplete
                          fullWidth
                          required
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={data1}
                          // value={Status.resellerName}
                          onChange={(e, val) => {
                            setSelectedUserDetailAssign({
                              ...selectedUserDetailAssign,
                              resellerName: val,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              size="small"
                              label="Select Reseller"
                            />
                          )}
                        />
                      </div>
                    </div> */}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      id="close_edit2"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-danger">
                      Delete
                    </button>
                  </div>
                </form>

                {/* <form onSubmit={assignUserApi}>
                  <div className="modal-body">
                    <div className="mt-4">
                      <div className="row justify-content-center align-items-center mx-0 my-3">
                        <div className="col-4 px-0">
                          <h6 className="text-capitalize text-end">
                            Sender Id:
                          </h6>
                        </div>
                        <div className="col-4 px-0 ms-5">
                          <h6 className="">
                            {selectedUserDetailAssign?.senderId}
                          </h6>
                        </div>
                      </div>

                      <div className="row justify-content-center align-items-center mx-0 my-3">
                        <div className="col-4 px-0">
                          <h6 className="text-capitalize text-end">DltId:</h6>
                        </div>
                        <div className="col-4 px-0 ms-5">
                          <h6 className="">
                            {selectedUserDetailAssign?.dltId}
                          </h6>
                        </div>
                      </div>

                      <div className="row justify-content-center align-items-center mx-0 my-3">
                        <div className="col-4 px-0">
                          <h6 className="text-capitalize text-end">
                            Category:
                          </h6>
                        </div>
                        <div className="col-4 px-0 ms-5">
                          <h6 className="">
                            {selectedUserDetailAssign?.category}
                          </h6>
                        </div>
                      </div>

                      <div className="row justify-content-center align-items-center mx-0">
                        <div className="col-4 px-0">
                          <h6 className="text-capitalize text-end">
                            Assign Sender Id to:
                          </h6>
                        </div>
                        <div className="col-4 px-0 ms-5">
                          <Autocomplete
                            required
                            disablePortal
                            id="combo-box-demo"
                            options={data1}
                            sx={{ width: 200 }}
                            // value={Status.resellerName}
                            onChange={(e, val) => {
                              setSelectedUserDetailAssign({
                                ...selectedUserDetailAssign,
                                resellerName: val,
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Select Reseller"
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      id="close_edit"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Assign
                    </button>
                  </div>
                </form> */}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div className="card mb-3 mt-4">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              {/* <i className="material-icons opacity-10">person</i> */}
              <PermPhoneMsgIcon style={{ color: "white" }} />
            </div>
            <div style={{ marginLeft: "6rem" }}>
              <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
                View Voice Templates
              </p>
            </div>
          </div>

          <div className="card-body">
            <ul className="nav nav-tabs mt-2" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 active position-relative"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#AccountDetails"
                  type="button"
                  role="tab"
                  aria-controls="AccountDetails"
                  aria-selected="true"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "0",
                      approveAssignedType: null,
                    });

                    settotalPageCount(0);
                  }}
                >
                  Pending
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning">
                    {/* {data2?.admin?.pending == null ? 0 : data2?.admin?.pending} */}
                    {/* {data2?.[0] == undefined ? 0 : data2?.[0].count} */}
                    {Pendingcount ? Pendingcount : 0}
                    {/* {data?.length} */}
                  </span>
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 position-relative"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "1",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Approved
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
                    {/* {data2?.admin?.approved == null
                      ? 0
                      : data2?.admin?.approved} */}
                    {/* {data2?.[1]  ? 0 : data2?.[1].count} */}
                    {Approvedcount ? Approvedcount : 0}
                    {/* {data?.length}/ */}
                  </span>
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 position-relative"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "2",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Rejected
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {/* {data2?.admin?.rejected == null
                      ? 0
                      : data2?.admin?.rejected} */}
                    {/* {data2?.[2]  ? 0 : data2?.[2].count} */}
                    {Rejectcount ? Rejectcount : 0}
                    {/* {data?.length} */}
                  </span>
                </button>
              </li>
              {/* <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 position-relative"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "3",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Client Requested
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary">
                    {data2?.client == null ? 0 : data2?.client}
                  </span>
                </button>
              </li> */}
            </ul>

            {/* {Status.approveType == "1" && (
              <ul className="nav nav-tabs mt-2" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link ms-4 position-relative"
                    id="SenderMasking-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#SenderMasking"
                    type="button"
                    role="tab"
                    aria-controls="SenderMasking"
                    aria-selected="false"
                    onClick={() => {
                      setStatus({
                        ...Status,
                        approveAssignedType: "0",
                      });
                    }}
                  >
                    Assigned
                   
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link ms-4 position-relative"
                    id="SenderMasking-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#SenderMasking"
                    type="button"
                    role="tab"
                    aria-controls="SenderMasking"
                    aria-selected="false"
                    onClick={() => {
                      setStatus({
                        ...Status,
                        approveAssignedType: "1",
                      });
                    }}
                  >
                    Not Assigned
                 
                  </button>
                </li>
              </ul>
            )} */}

            <div className="d-flex flex-wrap justify-content-between my-3">
              {Status.hideShow && (
                <>
                  {/* <div className="d-flex">
                    <Autocomplete
                      required
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={data1}
                      sx={{ width: 300 }}
                      // value={Status.resellerName}
                      onChange={(e, val) => {
                        console.log({ val });
                        setStatus({
                          ...Status,
                          resellerName: val,
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          required
                          {...params}
                          label="Select Reseller/User"
                        />
                      )}
                    />

                   
                    <div
                      className="d-flex justify-content-between mx-3"
                      style={{ width: "300px" }}
                    >
                      <FormControl fullWidth>
                        <InputLabel size="small" id="test-select-label">
                          Select Type
                        </InputLabel>
                        <Select
                          size="small"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={Status.type}
                          label="Select Type"
                          onChange={(e) => {
                            setStatus({
                              ...Status,
                              type: e.target.value,
                            });
                          }}
                        >
                          {[
                            { id: 0, name: "All", value: null },
                            {
                              id: 1,
                              name: "Promotional",
                              value: "Promotional",
                            },
                            {
                              id: 2,
                              name: "Transactional",
                              value: "Transactional",
                            },
                          ].map((d) => {
                            return (
                              <MenuItem value={d.value}> {d.name}</MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>

                    <div className="d-flex justify-content-between">
                      <button
                        disabled={
                          Status.type == null && Status.resellerName == null
                        }
                        onClick={fetchUserr}
                        className={
                          Status.type == null && Status.resellerName == null
                            ? "btn btn-secondary"
                            : "btn btn-primary"
                        }
                      >
                        Filter
                      </button>
                    </div>
                  </div> */}
                </>
              )}

              {/* <div className="text-end" style={{ flexGrow: "1" }}>
                <IconButton
                  variant="text"
                  size="small"
                  sx={{
                    color: "#7B809A",
                  }}
                  onClick={(event) => {
                    setStatus({
                      ...Status,
                      hideShow: !Status.hideShow,
                    });
                  }}
                >
                  {Status.hideShow ? <CancelIcon /> : <SearchIcon />}
                </IconButton>
              </div> */}
            </div>

            {data.length > 0 ? (
              <>
                <>
                  <div className="d-flex justify-content-between my-3">
                    <div className="d-flex justify-content-between">
                      <select
                        value={pageSize}
                        className="dropdown"
                        onChange={(e) => {
                          setPageSize(Number(e.target.value));
                        }}
                      >
                        {[10, 25, 50].map((value, i) => {
                          return (
                            <option
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                              value={value}
                              key={value}
                            >
                              Show {value}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <TextField
                      className="ms-4"
                      style={{
                        borderRadius: "4px",
                      }}
                      type="text"
                      label="Search"
                      name="Search"
                      variant="outlined"
                      // value={number}
                      size="small"
                      value={globalSearchValue || ""}
                      onChange={(e) => {
                        onChange(e.target.value);
                        setGlobalSearchValue(e.target.value);
                      }}
                    />
                  </div>
                </>

                <div className="text-end">
                  {selectedFlatRows.length > 0 && (
                    <button
                      onClick={deletUser}
                      className="btn bg-gradient-primary m-0"
                    >
                      Delete Users
                    </button>
                  )}
                </div>

                <div className="table-responsive">
                  <table
                    {...getTableProps()}
                    id="example"
                    className="table table-striped table-bordered dataTable table-sm mt-3"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      {headerGroups?.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <th
                              {...column.getHeaderProps(
                                column.getSortByToggleProps()
                              )}
                              className="text-center width_2"
                            >
                              {column.render("Header")}
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? "↑"
                                    : "↓"
                                  : ""}
                              </span>
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  className="text-left"
                                >
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between">
                  <div>
                    <span>
                      Page:
                      <strong>
                        {/* {pageIndex + 0} of {pageOptions.length} */}
                        {totalPageCount + 1} of {totalPage}
                      </strong>
                    </span>

                    <span>
                      | Go to Page :{""}
                      {/* <input
                        type="number"
                        min="0"
                        max={totalPage}
                        // defaultValue={pageIndex}
                        // defaultValue={totalPageCount}
                        value={totalPageCount + 1}
                        pageNumber // defaultValue={pageNumber1}
                        onChange={(e) => {
                          const pageNumber = e.target.value
                            ? Number(e.target.value)
                            : 0;
                          gotoPage(pageNumber);
                          setPageNumber1(pageNumber);
                        }}
                        style={{ width: "50px" }}
                      /> */}
                      <input
                        type="number"
                        min={1}
                        max={totalPage}
                        // defaultValue={pageIndex}
                        // defaultValue={totalPageCount}
                        value={Number(totalPageCountShow)}
                        // defaultValue={pageNumber1}
                        onChange={(e) => {
                          console.log("EEEEE", e.target.value);
                          // const totalPageCountt = e.target.value
                          //   ? Number(e.target.value)
                          //   : 0;
                          if (e.target.value > totalPage) {
                            settotalPageCountShow(totalPage);
                            settotalPageCount(totalPage - 1);
                          } else if (totalPageCount == -1) {
                            settotalPageCount(0);
                          } else {
                            onChangeTe(e.target.value);
                          }
                          // gotoPage(totalPageCountt);
                          // setPageNumber1(totalPageCountt);

                          // setGlobalFilter(value || undefined);
                          // settotalPageCountShow(e.target.value || undefined);
                          // settotalPageCount(e.target.value - 1 || undefined);
                        }}
                        style={{ width: "50px" }}
                      />
                    </span>
                  </div>

                  <div>
                    <button
                      className="btn btn_primary m-0 primary_1 me-2"
                      type="button"
                      // disabled={!canPreviousPage}
                      disabled={totalPageCount == 0}
                      onClick={() => {
                        previousPage();
                        PreviousPage();
                      }}
                    >
                      Prev
                    </button>

                    <button
                      className="btn btn_primary m-0 primary_1"
                      type="button"
                      // disabled={!canNextPage}
                      disabled={totalPageCount + 1 == totalPage}
                      onClick={() => {
                        nextPage();
                        NextPage();
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className="text-center">
                <h5>Data Not Found</h5>
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
